module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// E:/R1/Angular/turnero/web-visor-cliente/~/core-js/modules/_function-to-string.js
// module id = ../../../../core-js/modules/_function-to-string.js
// module chunks = 0